import React from 'react';
import './CpaAddressInput.scss';
import PropTypes from 'prop-types';
import { Input } from '@thd-olt-component-react/input';
import { notEmptyRegex } from '@thd-olt-functional/utils';
import { validate, validateRequiredInput } from '../../constants/constants';
import { InformationalMessage } from '../InformationalMessage/InformationalMessage';

const handleValidation = (text) => {
  return validateRequiredInput(text)
          && validate(text, notEmptyRegex)
          && text.trim() !== '';
};

const CpaAddressInput = (props) => {
  const {
    header, value, callback, name
  } = props;
  return (
    <div className="cpa-input">

      <InformationalMessage
        body="If you do not provide a physical address, there may be challenges in verifying your request."
        header="Physical Address Recommended"
      />

      <div className="cpa-input__tooltip-header">
        {header}
      </div>
      <Input
        name={name}
        className="cpa-form-input"
        errorText="Please enter a valid address."
        value={value}
        onChange={(event) => callback(event, name, handleValidation(event))}
        validation={handleValidation}
      />
    </div>
  );
};

CpaAddressInput.propTypes = {
  callback: PropTypes.func.isRequired,
  header: PropTypes.element.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

CpaAddressInput.displayName = 'CpaAddressInput';

export { CpaAddressInput };
